import AfterSalesCtas from './AfterSalesCtas';

export default AfterSalesCtas;
